import * as actions from './currentToastActionTypes';

export const addToast = toastStack => ({
    type: actions.CURRENT_TOAST_ADD,
    toastStack
})

export const clearToastList = toastStack => ({
    type: actions.CURRENT_TOAST_CLEAR
})